import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {MapChart} from 'angular-highcharts';
import * as worldMap from '@highcharts/map-collection/custom/world.geo.json';
import {Axis, PointOptionsObject, SeriesMapDataOptions, SeriesOptionsType} from 'highcharts';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-visible-fee-map-chart',
  templateUrl: './visible-fee-map-chart.component.html',
  styleUrls: ['./visible-fee-map-chart.component.scss']
})
export class VisibleFeeMapChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: MapChart;
  chartData!: SeriesOptionsType[];
  textBelowCode = 'intelligence.Country.VisibleFee.textBelow';
  isAdmin!: boolean;

  @Input()
  title!: string;
  @Input()
  subtitle!: string;
  @Input()
  data!: IntelligenceData[];
  @Input()
  responseType!: string | undefined;

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.chartData = this.convertToChartData();
      this.chart = new MapChart({
        chart: {
          map: worldMap
        },
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        legend: {
          enabled: false
        },
        mapNavigation: {
          enabled: true
        },
        credits: {
          text: '© WEEE Forum Key Figures | Highcharts.com'
        },
        exporting : {
          csv: {
            columnHeaderFormatter: (item: any, key: any) => {
              if (!item || item instanceof Axis) {
                return 'Country';
              } else {
                return item.name;
              }
            }
          },
          buttons: {
            contextButton: {
              menuItems:  ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG',
                'downloadCSV', 'viewData'],
            }
          },
          menuItemDefinitions: {
            downloadCSV: {
              text: 'Download data'
            }
          }
        },
        tooltip: {
          formatter(): string[] | undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              if (pointOptions.custom?.absolute === 0) {
                return [this.point.name];
              }
              return ['<div class="center"><b>' + this.point.name + ' - ' + `${pointOptions.custom?.year}</b></div><br><br>`,
                `- Country response: ${pointOptions.custom?.answer} <br>` +
                `- Total responses: ${pointOptions.custom?.totalResponses} <br>` +
                `- Is visible fee mandatory?: ${pointOptions.custom?.mandatory}`

              ];
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        series: this.chartData
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: {code: this.textBelowCode}}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): SeriesOptionsType[] {
    this.chart?.ref?.hideData();
    const chartData = [] as SeriesOptionsType[];
    const existenceOfAFee = this.data.filter(item => item.questionCode === 'D0160400B');
    const mandatoryFee = this.data.filter(item => item.questionCode === 'D0160410B');
    const data = existenceOfAFee.map(item => ({
      category: 'Country',
      key: item.countryCode.toLowerCase(),
      value: item.answer || undefined,
      color: item.answer ? item.answer.toLowerCase().includes('yes') ? '#6db530' : '#FF0000' : '#FF0000',
      custom: {
        year: item.year,
        answer: item.answer ? item.answer.toLowerCase().includes('yes') || item.answer.toLowerCase().includes('true') ? 'Yes' : 'No' : 'No',
        totalResponses: existenceOfAFee.length,
        mandatory: mandatoryFee.find(i => item.countryCode === i.countryCode && item.year === i.year)?.answer || 'No data'
      }
    } as SeriesMapDataOptions));
    chartData.push({
      name: 'Answer',
      joinBy: ['hc-key', 'key'],
      type: 'map',
      data
    });
    return chartData;
  }

}
